// extracted by mini-css-extract-plugin
export default {"loading":"onPh27l7QDU3Kbl9wOdi"};